/**
 * Handles the filterable company list.
 */

const activeFilterClasses = ['active'];

export const initializeFilterableCompanies = () => {
    const containers = document.querySelectorAll('.js-companies-filtering-container');

    if (containers.length === 0) return;

    containers.forEach((container) => {
        const filterButtons = container.querySelectorAll('.js-companies-button');
        const list = container.querySelector('.js-companies-list');

        if (!filterButtons.length || !list) return;

        const companyItems = list.querySelectorAll('.js-company-item');

        if (!companyItems.length) return;

        const activeFilters = new Set();

        const updateGrid = () => {
            const items = Array.from(list.children);
            const columnCount = 2;

            // Redistribute items evenly across columns
            items.forEach((item, index) => {
                item.style.order = index % columnCount;
            });
        };

        const filterCompanies = () => {
            companyItems.forEach((item) => {
                const codes = item
                    .getAttribute('data-company-service-codes')
                    ?.split(', ')
                    .map((code) => code.trim()) || [];

                // Check if all active filters are in the company's codes
                const matches = Array.from(activeFilters).every((filter) =>
                    codes.includes(filter)
                );

                // Show or hide the company based on the match
                item.style.display = matches ? 'flex' : 'none';
            });

            updateGrid();
        };

        const toggleFilter = (button) => {
            const code = button.getAttribute('data-service-codes');
            if (activeFilters.has(code)) {
                activeFilters.delete(code);
                button.classList.remove(...activeFilterClasses);
                button.blur();
            } else {
                activeFilters.add(code);
                button.classList.add(...activeFilterClasses);
            }

            filterCompanies();
        };

        filterButtons.forEach((button) => {
            button.addEventListener('click', () => toggleFilter(button));
        });

        // Ensure grid is balanced on initial load
        updateGrid();
    });
};
